import React from 'react'

export default function ButtonForm({content, styleButton, onClick, title}) {
  return (
    <button title={title} onClick={onClick} className={styleButton}>{content}</button>
  )
}